import {BaseViewModel} from "../../../infrastructure/models/base-view-model";
import {RankingsDomainModel} from "./rankings.domain-model";

export class RankingsViewModel extends BaseViewModel {
  domainModel: RankingsDomainModel;

  get name(): String {
    return this.domainModel.name;
  }

  get shortName(): String {
    return this.domainModel.shortName;
  }

  get position(): Number {
    return this.domainModel.position;
  }

  toString(): String {
    return `${this.name || this.shortName} ${this.position}`;
  }
}